import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';


const DocsForum = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.monto_cuota + doc.monto_interes + doc.gasto_cobranza)}, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {

        //console.log('🐞DEBUG llegamos?????');

        // const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.monto_cuota + doc.monto_interes + doc.gasto_cobranza); }, 0);
        // props.setDebtFn(totalDebt);
        const debtActiveDocs = props.documents.reduce((acc, doc) => doc.activo ? acc + Number(doc.monto_cuota + doc.monto_interes + doc.gasto_cobranza) : acc, 0);
        props.setDebtFn(debtActiveDocs);

        const activeDocuments = props.documents.reduce((acc, doc) => doc.activo?acc+1:acc, 0);
        props.setDocumentsLength(activeDocuments);

    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Tipo Credito</th>
                    <th className='right'>N. Contrato</th>
                    <th className='right'>S.Insoluto</th>
                    <th className='right'>N.Cuota</th>
                    <th className='center'>Fecha Pago Cuota</th>
                    <th className='center'>Días Mora</th>
                    <th className='center'>Monto Cuota</th>
                    <th className='center'>Interes</th>
                    <th className='right'>G.Cobranza</th>
                    <th className='right'>Total</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        doc.activo?(
                            <tr key={index}>
                                <td>
                                    <label className="forCheckbox">
                                        <input type="checkbox" name={'ckeck' + index} value={doc.monto_cuota + doc.monto_interes + doc.gasto_cobranza} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                        {doc.tipo_credito} / {doc.indicador} / {doc.codigo_producto}
                                    </label>
                                </td>
                                <td className="center">{doc.num_contrato}</td>
                                <td className="right">{Tools.fmtClAmmount(doc.saldo_insoluto)}</td>
                                <td className="right">{doc.num_cuota} / {doc.total_cuota}</td>
                                <td className="center">{doc.fecha_pago_cuota}</td>
                                <td className="right">{doc.dias_mora}</td>
                                <td className="right">{Tools.fmtClAmmount(doc.monto_cuota)}</td>
                                <td className="right">{Tools.fmtClAmmount(doc.monto_interes)}</td>
                                <td className="right">{Tools.fmtClAmmount(doc.gasto_cobranza)}</td>
                                <td className="right">{Tools.fmtClAmmount(doc.monto_cuota + doc.monto_interes + doc.gasto_cobranza)}</td>
                            </tr>
                        ):null
                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsForum;